module.exports = ol.layer.Layer;